import { identify, makeRequest, Service } from '../../../utils/http';

type Data = {
  deliveryId: string;
};

export async function rejectDeliveryApi({ deliveryId }: Data) {
  return makeRequest(Service.rejectDelivery(deliveryId, await identify()));
}
